export default "__VITE_ASSET__15b0f855__"